import { ISO3166Alpha3 } from "@faire/web-api/indigofair/iso3166/ISO3166Alpha3";
export var countryToISO = function countryToISO(countryCode) {
  return countryCode !== null && countryCode !== void 0 ? countryCode : ISO3166Alpha3.USA;
};